const EventBus = window.VueEventBus
import { getNow } from '../../../lib/dates'
import RaceCartItemMixin from '../../../components/_mixins/race-cart-item'
import ProviderService from '../../../services/provider'
import NinjaCartItem from './types/ninja-cart-item'
import PackagesCartItem from './types/packages-cart-item'
import RaceCartItem from './types/race-cart-item'

export default {
  name: 'race-reservations-cart-item',
  settings: 'page.cart',
  translations: 'page.cart',
  mixins: [RaceCartItemMixin],
  components: {NinjaCartItem, PackagesCartItem, RaceCartItem},
  data() {
    return {}
  },
  created() {
  },
  computed: {
  },
  methods: {

  },
}
